import { CategoriaCircularizacao } from '../interfaces/ICircularizacao';

const SLUG_POR_CATEGORIA: Record<CategoriaCircularizacao, string> = {
  FORNECEDORES: 'fornecedores',
  BANCOS: 'bancos',
  JURIDICO: 'juridico',
  CLIENTES: 'clientes',
  PARTES_RELACIONADAS: 'partes-relacionadas',
};

const CATEGORIA_POR_SLUG: Record<string, CategoriaCircularizacao> = Object.fromEntries(
  Object.entries(SLUG_POR_CATEGORIA).map(([categoria, slug]) => [slug, categoria as CategoriaCircularizacao])
);

export const categoriaParaSlug = (categoria: CategoriaCircularizacao): string => SLUG_POR_CATEGORIA[categoria];

export const slugParaCategoria = (slug: string): CategoriaCircularizacao | undefined => CATEGORIA_POR_SLUG[slug];
